/*
 *   File : edit-store.js
 *   Author : https://evoqins.com
 *   Description : Change sales specialist store modal
 *   Integrations : react-toastify
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

// Custom components
import { Icon } from '../Icon';
import { CustomSelectBox } from '../FormElements';
import { PrimaryButton } from '../Buttons';
import { Loader } from '../Others';
import { APIService } from '../../Service';

const EditStoreModal = (props) => {

    const [selectedStore, setSelectedStore] = useState(null);
    const [selectedStoreError, setSelectedStoreError] = useState("");
    const [submitLoader, setSubmitLoader] = useState(false);

    useEffect(() => {
        if (props.status === true) {
            _handleCloseModal();
        }
    }, [props.status]);

    useEffect(() => {
        setSelectedStoreError("");
    }, [selectedStore]);

    useEffect(() => {
        if (props.currentStoreId == null) {
            setSelectedStore(null);
            return;
        }

        setSelectedStore({
            value: props.currentStoreId,
            label: props.currentStoreName,
        });
    }, [props.currentStoreId, props.currentStoreName]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("edit-store-modal-close");
        button.click();
        props.handleClose();

        setSelectedStoreError("");
        setSelectedStore(null);
    };

    // handle success modal
    const _handleSuccess = () => {
        var button = document.getElementById("edit-store-modal-close");
        button.click();
        props.handleSuccess();

        setSelectedStoreError("");
        setSelectedStore(null);
    };

    // handle submit
    const _handleSubmit = () => {
        if (selectedStore === null) {
            setSelectedStoreError("Select a store");
            return;
        }
        setSubmitLoader(true);
        _changeStore();
    };

    // API - Change store
    const _changeStore = () => {
        let is_post = true;
        let url = 'CA/sales-specialist/change-store';
        let data = {
            "customer_id": props.customerId,
            "store_id": selectedStore.value
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                _handleSuccess();
                toast.dismiss();
                toast.success("Store updated successfully", {
                    type: "success",
                    className: "e-toast",
                });
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setSubmitLoader(false);
        }).catch(() => {
            setSubmitLoader(false);
            toast.dismiss();
            toast.error("Failed to update store", {
                type: "error",
                className: "e-toast",
            });
        });
    };

    return (
        <div className="modal fade"
            id="edit-store-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="editStoreModalLabel"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable e-border-radius-24">
                <div className="modal-content e-border-radius-12 overflow-hidden">
                    <img src={require("../../Assets/Image/CountryAdmin/close-icon.svg").default}
                        draggable={false}
                        id='edit-store-modal-close'
                        className='d-none '
                        alt='close'
                        data-bs-dismiss="modal" />
                    {props.loading ?
                        <Loader className="h-30vh py-4 my-0 justify-content-center d-flex align-items-center " />
                        :
                        <>
                            <div className="modal-header align-items-start flex-column px-4 pt-4 border-0">
                                <div className='d-flex justify-content-between w-100 mb-2'>
                                    <h4 className="mb-0 e-primary-font-playfair e-text-dark-jungle-green e-font-18 e-font-weight-500 line-height-28px">
                                        Change store
                                    </h4>
                                    <Icon icon="close-icon"
                                        className='cursor-pointer'
                                        size="24px"
                                        onPress={_handleCloseModal} />
                                </div>
                                <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                    To proceed, select the store from the dropdown.
                                </p>
                            </div>

                            <div className='modal-body py-0 px-4'>
                                <CustomSelectBox label="Store"
                                    placeholder="Select store"
                                    value={selectedStore}
                                    options={props.options || []}
                                    error={selectedStoreError}
                                    className="e-modal-select"
                                    fontWeight="500"
                                    menuPortalTarget={document.body}
                                    isSearchable={true}
                                    selectChange={(value) => { setSelectedStore(value); }} />
                            </div>

                            <div className='modal-footer px-4 py-4 border-0'>
                                <PrimaryButton name="Submit"
                                    status={submitLoader}
                                    onPress={_handleSubmit} />
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

export default EditStoreModal;
